import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";

import BlockFloatingOptions from "@/content-hub/editor/floating-options/block-floating-options";
import RichText from "@/content-hub/theme/primitives/rich-text";
import Video from "@/content-hub/theme/primitives/video/video";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/content-hub/theme/shared/block-wrapper";

import { MAX_WIDTHS } from "./constants";
import VideoWithTitleSettings, {
  VIDEO_AREA_SIZE_LARGE_TYPE,
  VIDEO_AREA_SIZE_MEDIUM_TYPE,
  VIDEO_AREA_SIZE_SMALL_TYPE,
} from "./video-with-title-settings";
import { PaddingContainer, Wrapper } from "./video-with-title-styles";

export type VideoWithTitleBlockProps = {
  videoAreaSize?:
    | typeof VIDEO_AREA_SIZE_SMALL_TYPE
    | typeof VIDEO_AREA_SIZE_MEDIUM_TYPE
    | typeof VIDEO_AREA_SIZE_LARGE_TYPE;
};

export default function VideoWithTitle({
  videoAreaSize = VIDEO_AREA_SIZE_SMALL_TYPE,
}: VideoWithTitleBlockProps) {
  const {
    id,
    connectors: { connect },
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={id} data-section-id={id}>
      <PaddingContainer>
        <BlockMaxWidthWrapper
          data-testid="video-area-wrapper"
          maxWidth={rem(MAX_WIDTHS[videoAreaSize])}
        >
          {videoAreaSize === VIDEO_AREA_SIZE_SMALL_TYPE && (
            <Wrapper data-testid="video-area-title">
              <Element
                id="title"
                is={RichText}
                text="<h2 style='text-align: center;'>Build Dynamic Content Hubs That Engage and Convert</h2>
                <p style='text-align: center;'>Create branded, AI-enhanced content experiences that showcase your best work, drive audience interaction, and turn views into meaningful connections—all in one place.</p>"
              />
            </Wrapper>
          )}
          <Element id="video" is={Video} url="https://youtu.be/hgIkL5sCu08" />
        </BlockMaxWidthWrapper>
      </PaddingContainer>
    </BlockBackgroundColorWrapper>
  );
}

VideoWithTitle.craft = {
  custom: {
    displayName: "Video with title",
    settingsTitle: "Video with title",
  },
  related: {
    settings: VideoWithTitleSettings,
    leftOutlineOptions: BlockFloatingOptions,
  },
};
